import { motion, useReducedMotion } from "framer-motion";
import { PhotoBackground } from "@/components/site/PhotoBackground";

const Line = ({ children, delay, reduce }) => (
    <span className="block overflow-hidden pb-[0.16em] -mb-[0.16em]">
        <motion.span
            className="block"
            initial={reduce ? false : { y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const PageHero = ({ kicker, lines, lede, testid, image }) => {
    const reduce = useReducedMotion();
    return (
        <section data-testid={testid} className="relative overflow-hidden border-b border-slate-800/70 pt-32 sm:pt-40">
            {image && <PhotoBackground src={image} eager />}
            <div className="relative mx-auto max-w-7xl px-4 pb-16 sm:px-6 sm:pb-20 lg:px-12 lg:pb-24">
                <motion.p
                    initial={reduce ? false : { opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                    className="font-mono text-[11px] uppercase tracking-[0.3em] text-blue-400"
                >
                    {kicker}
                </motion.p>
                <h1 className="mt-6 max-w-4xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-slate-100 sm:text-5xl lg:text-6xl">
                    {lines.map((line, i) => (
                        <Line key={line} delay={0.2 + i * 0.15} reduce={reduce}>
                            {line}
                        </Line>
                    ))}
                </h1>
                {lede && (
                    <motion.p
                        initial={reduce ? false : { opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.55, ease: [0.16, 1, 0.3, 1] }}
                        className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg"
                    >
                        {lede}
                    </motion.p>
                )}
            </div>
        </section>
    );
};
